










import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AuthRegisterForm from "@/components/AuthRegisterForm.vue";

@Component({
  components: { AuthRegisterForm }
})
export default class CompanyAdd extends Vue {
  @Prop({ default: false }) value!: boolean;

  @Watch("value")
  onVisibleChanged(newValue: boolean) {
    if (newValue) {
      this.$nextTick(() => {
        (this.$refs.registerForm as AuthRegisterForm).reset();
      });
    }
  }

  close() {
    this.$emit("input", false);
  }
}
